import { AppBar as RaAppBar, AppBarProps } from '@react-admin/ra-enterprise'

export const AppBar = (props: AppBarProps) => {
   return <RaAppBar {...props} languages={[]}></RaAppBar>
}
